export default "__VITE_ASSET__q$YXU9w8__"